import { Card } from 'react-bootstrap';

const BankDetailsSection = ({ employee, onPreview }) => {
  const bank = employee?.bank || {};

  const maskAccountNumber = (accountNumber) => {
    if (!accountNumber) return 'N/A';
    const last4 = accountNumber.slice(-4);
    return `****${last4}`;
  };

  return (
    <Card className="mb-3">
      <Card.Header className="bg-warning text-dark">
        <h6 className="mb-0">Bank Details</h6>
      </Card.Header>
      <Card.Body>
        <div className="profile-field">
          <div className="profile-field-label">Account Number:</div>
          <div className="profile-field-value">{maskAccountNumber(bank.accountNumber)}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Account Holder Name:</div>
          <div className="profile-field-value">{bank.accountHolderName || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Bank Name:</div>
          <div className="profile-field-value">{bank.bankName || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Branch Name:</div>
          <div className="profile-field-value">{bank.branchName || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">IFSC Code:</div>
          <div className="profile-field-value">{bank.ifscCode || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Account Type:</div>
          <div className="profile-field-value">{bank.accountType || 'N/A'}</div>
        </div>
        {bank.document && (
          <div className="profile-field mt-3">
            <div className="profile-field-label">Passbook Scan:</div>
            <div className="profile-field-value">
              <button 
                type="button"
                onClick={() => onPreview(bank.document, 'Bank Passbook / Cheque Scan')}
                className="btn btn-sm btn-outline-warning py-0"
              >
                View Passbook / Cheque
              </button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default BankDetailsSection;
